<script lang="ts" setup>
  import { inject, onMounted } from "vue";
  import { useSessionStore } from "@/stores/session";
  import { useAppStore } from "@/stores/app";
  import type { VueCookies } from "vue-cookies";
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";

  const cookies: VueCookies | undefined = inject<VueCookies>('$cookies');
  const referralRockURL = `${import.meta.env.VITE_APP_REFERRAL_ROCK_URL}`;

  const appStore = useAppStore();
  const subscriptionFlowStore = useSubscriptionFlowStore();
  const referralProgramId = appStore.client?.referralProgramId ?? null;
  if (!appStore.isReferralEnabled) {
    subscriptionFlowStore.advanceStep();
  }

  const sessionStore = useSessionStore();
  const loggedUser = sessionStore.loggedUser;
  const firstName = loggedUser?.firstName;
  const lastName = loggedUser?.lastName;
  const email = loggedUser?.email;

  const referralUIWidgetURL = referralRockURL + '/access?'
    + 'programidentifier=' + referralProgramId
    + '&view=iframe'
    + '&firstname=' + firstName
    + '&lastname=' + lastName
    + '&email=' + email;

  onMounted(() => {
    cookies?.set('change_it_rr_shown', true, '7d');
  });
</script>

<template>
  <div class="content">
    <iframe
      class="referral-rock-container"
      :src="referralUIWidgetURL"
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
    ></iframe>
    <div>
      <h3 class="step-header">{{ $t('common.how-it-works') }}</h3>
      <div class="steps-container">
        <div class="steps">
          <div class="step">1</div>
          <span class="step-text">{{ $t(`modal.referral-rock.${appStore.labelVersion}.step1`) }}</span>
        </div>
        <div class="steps">
          <div class="step">2</div>
          <span class="step-text">{{
              $t(`modal.referral-rock.${appStore.labelVersion}.step2`, { clientName: appStore.client!.name })
            }}</span>
        </div>
        <div class="steps">
          <div class="step">3</div>
          <span class="step-text">{{
              $t(`modal.referral-rock.${appStore.labelVersion}.step3`, { reward: $n(appStore.client!.referralReward, 'currency') })
            }}.</span>
        </div>
      </div>
    </div>
    <div class="mt-2">
      <v-btn
        type="submit"
        color="primary"
        width="320"
        rounded="lg"
        @click="subscriptionFlowStore.advanceStep"
      >
        {{ $t('common.next') }}
      </v-btn>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    text-align: center;
    height: 100%;

    iframe {
      width: 100%;
      height: 410px;
      border: 0 none transparent;
      margin: 0;
      padding: 0;
      visibility: visible;
      display: block;

      @media screen and (max-width: breakpoint(md) - 1px) {
        height: 480px;
      }
    }


    .step-header {
      font-size: 20px;
      font-weight: 700;
      margin-top: 25px;
    }

    .steps-container {
      margin: 1.5rem 0;
      display: flex;
      justify-content: center;
      gap: 50px;

      @media screen and (max-width: breakpoint(md) - 1px) {
        flex-direction: column;
        align-items: center;
      }
    }

    .step-text {
      color: #0F1B32;
      font-size: 14px;
    }

    .steps {
      width: 172px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;

      .step {
        border: 1px solid #CCD7E1;
        width: 37px;
        height: 37px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
      }
    }
  }

  .rotate-45 {
    :deep(.icon) {
      transform: rotate(315deg);
    }
  }

</style>